import { useNavigation } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';
import DefaultScreenContainer from '../../../components/DefaultScreenContainer';
import InfoItem from './components/InfoItem';
import Text from '../../../components/Text';
import Column, { ColumnType } from './components/Column';
import { Button, OfferBanner } from '../../../components';

// import ArrowLeftSvg from '~/assets/svgs/arrow-left.svg';
import ExitConfirmationModal from '../components/ExitConfirmationModal';
// import { Logo } from '~/components/Header';

import BannerImg from '~/assets/img/banners/marisa-takes-care-banner.png';
import BannerImgDesk from '~/assets/img/banners/marisa-takes-care-banner-desk-offer.png';
import MarisaTakesCareSvg from '~/assets/svgs/marisa-takes-care-logo.svg';
// import colors from '~/assets/themes/colors';
import { isWeb } from '~/utils/device';

interface ColumnProps {
  id: number;
  texts: string[];
}

const COLUMNS: ColumnProps[] = [
  {
    id: 1,
    texts: [
      'Procedimento',
      'Consulta cardiologista',
      'Consulta Clinico Geral',
      'Ecocardiograma',
      'Eletrocardiograma',
      'Hemograma',
      'Teste Ergométrico',
      'Total Geral',
    ],
  },
  {
    id: 2,
    texts: [
      'Particular',
      'R$ 150,00',
      'R$ 150,00',
      'R$ 90,00',
      'R$ 90,00',
      'R$ 28,00',
      'R$ 259,00',
      'R$ 767,00',
    ],
  },
  {
    id: 3,
    texts: [
      'Rede mais',
      'R$ 70,00',
      'R$ 70,00',
      'R$ 45,00',
      'R$ 45,00',
      'R$ 12,00',
      'R$ 54,52',
      'R$ 296,52',
    ],
  },
  {
    id: 4,
    texts: [
      'Economia',
      'R$ 80,00',
      'R$ 80,00',
      'R$ 45,00',
      'R$ 45,00',
      'R$ 16,00',
      'R$ 204,48',
      'R$ 470,48',
    ],
  },
  {
    id: 5,
    texts: ['% Economia', '53%', '53%', '50%', '50%', '57%', '79%', '61%'],
  },
];

const bgColorByIndex = (index: number): string => {
  if (index % 2 === 0) {
    return 'bg-light-100';
  }
  return 'bg-gray-100';
};

const Insurance: React.FC = () => {
  const { goBack, setOptions } = useNavigation();

  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setOptions({
      // headerTitle: () => <Logo onPress={() => setModalVisible(true)} />,
    });
  }, [setOptions]);

  return (
    <DefaultScreenContainer>
      <ExitConfirmationModal
        visible={modalVisible}
        onDismiss={() => setModalVisible(false)}
      />

      <View className="container mx-auto">
        {!isWeb && (
          <OfferBanner
            hireInsurance={{
              showButton: false,
            }}
            images={{
              mobile: BannerImg,
              web: { banner: BannerImgDesk, badge: MarisaTakesCareSvg },
            }}
            insuranceName="Marisa Cuida"
            insuranceDetail="A Marisa Cuida da sua saúde
            para você"
          />
        )}

        <View className="px-6 mb-14">
          {/* {isWeb && (
            <>
              <TouchableOpacity
                className="flex-row items-center"
                onPress={() => goBack()}
              >
                <ArrowLeftSvg color={colors.gray[400]} />

                <Text className="text-xs ml-2 font-medium text-gray-400">
                  Voltar
                </Text>
              </TouchableOpacity>
            </>
          )} */}

          <Text className="text-primary-600 mb-4 text-xl mt-6">
            Assistência Saúde
          </Text>

          <Text className="text-gray-400 text-xs mb-4">
            Programa de saúde particular com preços reduzidos de até 80% em
            consultas médicas, exames laboratoriais/imagens presenciais e um
            completo serviço de bem-estar, através de rede credenciada nacional.
          </Text>

          <ScrollView
            className="flex-row"
            horizontal
            showsHorizontalScrollIndicator={false}
          >
            {COLUMNS.map((column) => {
              return (
                <View className="mr-[1px]" key={column.id}>
                  {column.texts.map((text, index) => {
                    const columnTypeA = (): ColumnType => {
                      if (index === 0) {
                        return ColumnType.header;
                      } else if (index === column.texts.length - 1) {
                        return ColumnType.total;
                      } else {
                        return ColumnType.default;
                      }
                    };

                    const columnType = columnTypeA();

                    const bgColor =
                      columnType === ColumnType.default
                        ? bgColorByIndex(index)
                        : '';

                    return (
                      <Column
                        key={index}
                        backgoundColor={bgColor}
                        type={columnType}
                        text={text}
                      />
                    );
                  })}
                </View>
              );
            })}
          </ScrollView>

          <Text className="text-gray-600 text-xs mt-4 mb-2 font-medium">
            Teletriagem com desfecho em Teleconsulta - Especialista
          </Text>

          <View>
            <Text className="text-xs text-gray-400 underline">
              Orientação Saúde
            </Text>
            <InfoItem description="Realizada por enfermeiros capacitados para orientar causas e sintomas e se necessário direcionar para médico plantonista" />
          </View>
          <View className="mt-2 mb-4">
            <Text className="text-xs text-gray-400 underline">
              Teleconsulta
            </Text>
            <InfoItem
              description="Atendimento 24x7 com equipe de médicos generalistas (clínico
              geral) ou especialistas mediante a agendamento prévio."
            />
          </View>

          <Text className="text-gray-600 font-medium mb-2 text-xs">
            Desconto em Medicamentos
          </Text>
          <InfoItem description="Desconto de 15% a 80% em diversos medicamentos." />
          <InfoItem description="Mais de 31.000 farmácias credenciadas pelo Brasil." />
          <InfoItem description="Desconto concedido para medicamentos com e sem prescrição médica." />

          <Text className="text-gray-600 font-medium mb-2 mt-4 text-xs">
            Check-up médico
          </Text>
          <InfoItem
            description="Cobertura de consulta médica preventiva com clínico geral
            (presencial), realização de exames e retorno para avaliação dos
            resultados"
          />
        </View>

        <View
          className={`${
            !isWeb ? 'border-t border-gray-100' : ''
          } py-4 px-6 items-center justify-center lg:mx-auto lg:w-[328px]`}
        >
          <Button className="w-full" onPress={goBack}>
            VOLTAR
          </Button>
        </View>
      </View>
    </DefaultScreenContainer>
  );
};

export default Insurance;
